import React from "react";
import BannerRoot from "../BannerRoot";
import CalcFormItem from "../../CalcForm/CalcFormItem";
import CalcFormInput from "../../CalcForm/CalcFormInput";
import Button from "../../../UI/Button";
import styles from "./index.module.scss";
import { useFormik } from "formik";
import * as yup from "yup";
import { useCalculatorController } from "../../context/context";
import { RENEWAL_FIELD_MAX_COUNT, SURVEY_URL } from "../../constants";
import {
  setShowGratitudeModal,
  submitMetricForm,
  triggerCalcFormValidation,
} from "../../context/actions";

const FullMetricReport = () => {
  const { controller, dispatch } = useCalculatorController();
  const { isCalcFormSubmitted, isGratitudeModalSubmitted, renewalFieldsCount } =
    controller;
  const formik = useFormik({
    initialValues: {
      full_name: "",
      email: "",
      app_url: "",
    },
    validateOnChange: true,
    validationSchema: yup.object({
      full_name: yup.string().required(),
      email: yup.string().email().required(),
      app_url: yup.string().required(),
    }),
    onSubmit: (values) => {
      fetch(`${SURVEY_URL}?id=calculator`, {
        method: "POST",
        body: JSON.stringify({
          data: {
            url: values.app_url,
            email: values.email,
            full_name: values.full_name,
            position: "Developer",
          },
        }),
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (!isCalcFormSubmitted) {
        triggerCalcFormValidation(dispatch, true);
      } else {
        submitMetricForm(dispatch, true);

        if (
          !isGratitudeModalSubmitted &&
          renewalFieldsCount === RENEWAL_FIELD_MAX_COUNT
        ) {
          setShowGratitudeModal(dispatch, true);
        }
      }
    },
  });

  return (
    <BannerRoot className={styles.modal}>
      <div className={styles.wrapper}>
        <h3 className={styles.title}>Get full metrics report</h3>
        <form className={styles.form} onSubmit={formik.handleSubmit}>
          <CalcFormItem label="Full Name" htmlFor="full_name" variant="blue">
            <CalcFormInput
              type="text"
              name="full_name"
              id="full_name"
              placeholder="Full Name"
              value={formik.values.full_name}
              onChange={formik.handleChange}
              error={!!formik.errors.full_name}
            />
          </CalcFormItem>

          <CalcFormItem label="Work Email" htmlFor="email" variant="blue">
            <CalcFormInput
              type="text"
              name="email"
              id="email"
              placeholder="Work Email"
              value={formik.values.email}
              onChange={formik.handleChange}
              error={!!formik.errors.email}
            />
          </CalcFormItem>

          <CalcFormItem
            label="App URL/Company website"
            htmlFor="app_url"
            variant="blue"
          >
            <CalcFormInput
              type="text"
              name="app_url"
              id="app_url"
              placeholder="App URL/Company website"
              value={formik.values.app_url}
              onChange={formik.handleChange}
              error={!!formik.errors.app_url}
            />
          </CalcFormItem>

          <Button
            fullWidth
            title="Get the result"
            className={styles.button}
            type="submit"
          />
        </form>
      </div>
    </BannerRoot>
  );
};

export default FullMetricReport;
